import { render } from "./timenaut.svg?vue&type=template&id=5028eb42"
const script = {}
script.render = render

export default script